const BannerPlancha = () => {
  return <div className="banner-service-container">Planchado</div>;
};

export default BannerPlancha;
